/**
 * Asia Bicycle — Magicshine widgets (FTR LightSync + Dual-Zone + Bundle Tabs)
 * Loaded as a classic deferred script on Magicshine product pages.
 * Does NOT use @theme/component — safe inside product description HTML.
 */
(function () {
  'use strict';

  /* ——— FTR LightSync: sync .is-on with nested checkbox ——— */
  function syncFtrClass(root, input) {
    if (input.checked) {
      root.classList.add('is-on');
    } else {
      root.classList.remove('is-on');
    }
  }

  function initFtr(root) {
    if (root.getAttribute('data-ab-ftr-ready') === '1') return;
    root.setAttribute('data-ab-ftr-ready', '1');

    var input = root.querySelector('.ab-ftr-switch__input');
    if (!input) return;

    syncFtrClass(root, input);

    input.addEventListener('change', function () {
      syncFtrClass(root, input);
    });

    var stage = root.querySelector('.ab-ftr-switch__stage');
    if (stage) {
      stage.addEventListener('click', function () {
        input.checked = !input.checked;
        // fire change so listeners (and sync) run
        var ev;
        try {
          ev = new Event('change', { bubbles: true });
        } catch (e) {
          ev = document.createEvent('Event');
          ev.initEvent('change', true, false);
        }
        input.dispatchEvent(ev);
      });

      stage.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          stage.click();
        }
      });
    }
  }

  /* ——— Dual-Zone comparison slider ——— */
  function comparePercent(range) {
    var min = Number(range.min);
    var max = Number(range.max);
    if (!isFinite(min)) min = 0;
    if (!isFinite(max) || max === min) max = 100;
    var val = Number(range.value);
    if (!isFinite(val)) val = min;
    return Math.round(((val - min) / (max - min)) * 100);
  }

  function sync(root, range) {
    root.style.setProperty('--compare', String(comparePercent(range)));
  }

  function initCompare(root) {
    if (root.getAttribute('data-ab-compare-ready') === '1') return;
    root.setAttribute('data-ab-compare-ready', '1');
    root.classList.remove('ab-compare--nojs');

    var range = root.querySelector('.ab-compare__range');
    if (!range) return;

    function onRange() {
      sync(root, range);
    }

    range.addEventListener('input', onRange);
    range.addEventListener('change', onRange);

    sync(root, range);
  }



  /* ——— Bundle image tabs: toggle one panel; re-click collapses all ——— */
  function initBundleTabs(root) {
    if (root.getAttribute('data-ab-bundle-ready') === '1') return;
    root.setAttribute('data-ab-bundle-ready', '1');

    var buttons = root.querySelectorAll('.ab-bundle-tabs__btn');
    var panels = root.querySelectorAll('.ab-bundle-tabs__panel');

    // Prefer class-based open/close so CSS slide can run ([hidden] skips animation)
    for (var p0 = 0; p0 < panels.length; p0++) {
      panels[p0].removeAttribute('hidden');
      panels[p0].classList.remove('is-open');
      panels[p0].setAttribute('aria-hidden', 'true');
    }

    function closeAll() {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('is-active');
        buttons[i].setAttribute('aria-pressed', 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.remove('is-open');
        panels[j].setAttribute('aria-hidden', 'true');
      }
    }

    function openPanel(name) {
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i].getAttribute('data-panel') === name;
        if (on) {
          buttons[i].classList.add('is-active');
          buttons[i].setAttribute('aria-pressed', 'true');
        } else {
          buttons[i].classList.remove('is-active');
          buttons[i].setAttribute('aria-pressed', 'false');
        }
      }
      for (var j = 0; j < panels.length; j++) {
        var match = panels[j].getAttribute('data-panel') === name;
        if (match) {
          panels[j].classList.add('is-open');
          panels[j].setAttribute('aria-hidden', 'false');
        } else {
          panels[j].classList.remove('is-open');
          panels[j].setAttribute('aria-hidden', 'true');
        }
      }
    }

    for (var b = 0; b < buttons.length; b++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var name = btn.getAttribute('data-panel');
          var already = btn.classList.contains('is-active');
          if (already) {
            closeAll();
          } else {
            openPanel(name);
          }
        });
      })(buttons[b]);
    }
  }

  function boot() {
    var ftrs = document.querySelectorAll('.ab-ftr-switch');
    for (var i = 0; i < ftrs.length; i++) {
      initFtr(ftrs[i]);
    }
    var compares = document.querySelectorAll('.ab-compare');
    for (var j = 0; j < compares.length; j++) {
      initCompare(compares[j]);
    }
    var bundles = document.querySelectorAll('[data-ab-bundle-tabs]');
    for (var k = 0; k < bundles.length; k++) {
      initBundleTabs(bundles[k]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
